export const host = 'http://so.aswfoods.com:3000'

// 110.232.80.241